module.exports = __webpack_public_path__ + "static/media/degenoba_hallauer_menegus_pusins_cuesta.1be515df.jpg";